import React from 'react';
import PropTypes from 'prop-types';
import { Formik } from 'formik';
import Select from 'react-select';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';

// Styles
import { FormStyled, Row, Column } from '../../css/styles/form';
import { SelectStyled } from '../../css/styles/select';

const handleValidate = ({ description, equipment, employee }) => {
  const errors = {};
  if (!description) errors.description = 'OBRIGATÓRIO';
  if (!equipment) errors.equipment = 'OBRIGATÓRIO';
  if (!employee) errors.employee = 'OBRIGATÓRIO';
  return errors;
};

const handleSubmit = props => async (values, { setSubmitting, resetForm }) => {
  if (!props.technicalReport) {
    await props.onCreation({ ...values });
  } else {
    await props.onUpdate({ ...values });
  }
  setSubmitting(false);
  resetForm();
};

const TechnicalReportForm = props => {
  const {
    technicalReportUuid,
    onDelete,
    onNew,
    onEdit,
    technicalReport,
    technicalReports,
    employees,
    equipments,
    equipment,
    employee,
    description,
    activeOsButton,
  } = props;
  return (
    <Formik
      enableReinitialize={true}
      initialValues={{
        description: technicalReport?.description || description || '',
        employee: technicalReport?.employee || employee || '',
        equipment: technicalReport?.equipment || equipment || '',
        technicalReport: technicalReport?.uuid || '',
      }}
      validate={handleValidate}
      onSubmit={handleSubmit(props)}
    >
      {({
        values,
        handleChange,
        handleBlur,
        handleReset,
        isSubmitting,
        setFieldValue,
        dirty,
        errors,
        touched,
      }) => {
        return (
          <FormStyled>
            <h1>
              {technicalReport
                ? 'ALTERAR RELATÓRIO TÉCNICO'
                : 'NOVO RELATÓRIO TÉCNICO'}
            </h1>

            <ul>
              <Row>
                <Column>
                  <strong>DESCRIÇÃO</strong>
                  <textarea
                    id="description"
                    name="description"
                    type="text"
                    value={values.description}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                  {errors.description && touched.description && (
                    <span>{errors.description}</span>
                  )}
                </Column>
              </Row>

              <Row>
                <Column>
                  <strong>EMPREGADO</strong>
                  <Select
                    styles={SelectStyled}
                    id="employee"
                    value={values.employee}
                    placeholder="Selecione um empregado"
                    onChange={selectedOption => {
                      setFieldValue('employee', selectedOption);
                    }}
                    isSearchable
                    options={employees}
                    getOptionLabel={item => item.name}
                    getOptionValue={item => item.uuid}
                    menuPlacement="auto"
                    name="employee"
                    isLoading={false}
                    components={{ IndicatorSeparator: () => null }}
                    loadingMessage={() => 'Buscando empregados'}
                    noOptionsMessage={() => 'Não há empregados para exibir'}
                  />
                  {errors.employee && touched.employee && (
                    <span>{errors.employee}</span>
                  )}
                </Column>

                <Column>
                  <strong>EQUIPAMENTO</strong>
                  <Select
                    styles={SelectStyled}
                    id="equipment"
                    value={values.equipment}
                    placeholder="Selecione um veículo"
                    onChange={selectedOption => {
                      setFieldValue('equipment', selectedOption);
                    }}
                    isSearchable
                    options={equipments}
                    getOptionLabel={item => item.code}
                    getOptionValue={item => item.uuid}
                    menuPlacement="auto"
                    name="equipment"
                    isLoading={false}
                    components={{ IndicatorSeparator: () => null }}
                    loadingMessage={() => 'Buscando veículos'}
                    noOptionsMessage={() => 'Não há veículos para exibir'}
                  />
                  {errors.equipment && touched.equipment && (
                    <span>{errors.equipment}</span>
                  )}
                </Column>
              </Row>

              <Row>
                <div className="buttons-container">
                  <button type="submit" disabled={isSubmitting}>
                    SALVAR
                  </button>

                  <button
                    type="button"
                    onClick={handleReset}
                    disabled={!dirty || isSubmitting}
                  >
                    RESET
                  </button>

                  {technicalReport && (
                    <>
                      <button type="button" onClick={onNew}>
                        LIMPAR
                      </button>
                      {!activeOsButton && (
                        <button type="button">
                          <Link
                            style={{ textDecoration: 'none', color: 'inherit' }}
                            to={{
                              pathname: 'maintenances',
                              state: {
                                description: values.description,
                                equipment: values.equipment,
                                employee: values.employee?.name,
                                technicalReport: values.technicalReport,
                              },
                              style: {
                                textDecoration: 'none',
                                color: 'inherit',
                              },
                            }}
                          >
                            Gerar OS
                          </Link>
                        </button>
                      )}
                    </>
                  )}
                </div>
              </Row>
            </ul>

            {/* <hr /> */}
            {/* O código comentado abaixo */}
            {/* 
            <ul>
              <Row>
                <Column>
                  <strong>RELATÓRIO TÉCNICO</strong>
                  <Select
                    styles={SelectStyled}
                    id="technicalReport"
                    value={values.technicalReport}
                    placeholder="Selecione um relatório técnico"
                    onChange={selectedOption => {
                      setFieldValue('technicalReport', selectedOption);
                      onEdit(selectedOption);
                    }}
                    isSearchable
                    options={technicalReports}
                    getOptionLabel={item => item.description}
                    getOptionValue={item => item.uuid}
                    name="technicalReport"
                    isLoading={false}
                    components={{ IndicatorSeparator: () => null }}
                    loadingMessage={() => 'Buscando relatórios técnicos'}
                    noOptionsMessage={() => 'Não há relatórios técnicos cadastrados'}
                  />
                </Column>
              </Row>
            </ul>
            */}
          </FormStyled>
        );
      }}
    </Formik>
  );
};

TechnicalReportForm.propTypes = {
  pieces: PropTypes.arrayOf(
    PropTypes.shape({
      description: PropTypes.string,
    })
  ),
  piece: PropTypes.shape({
    description: PropTypes.string,
  }),
  onDelete: PropTypes.func.isRequired,
  onNew: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
};

TechnicalReportForm.defaultProps = {
  technicalReports: [],
  technicalReport: null,
};

export default TechnicalReportForm;

